export function nodesBetween(start: Node, end: Node): Node[] {
    if (start.parentNode !== end.parentNode) {
        throw new Error("Cannot get nodes between nodes with different parents");
    }
    let current = start.nextSibling;
    const nodes: Node[] = [];
    nodes.push(start);
    while (current && current !== end) {
        nodes.push(current);
        current = current.nextSibling;
    }
    nodes.push(end);
    return nodes;
}
